// taggedjs-no-compile
export const variablePrefix = ':tagvar';
export const variableSuffix = ':';
